class SubscriptionButton extends HTMLElement {
  constructor() {
    super();
    this.isActive = false;

    // Observer setup
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.classList.remove("in-view");
          } else {
            this.classList.add("in-view");
          }
        });
      },
      {
        root: null,         
        rootMargin: "0px",  
        threshold: 0       
      }
    );
  }

  connectedCallback() {
    this.attachEventListeners();
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  attachEventListeners() {
    const toggleSwitch = this.querySelector(".toggle-switch");
    const infoIcon = this.querySelector(".info-icon");
    const tooltip = this.querySelector(".tooltip");
    const productItems = [
      ...document.querySelectorAll(".product-item.product-item-with-form"),
    ];

    toggleSwitch.addEventListener("click", () => {
      this.isActive = !this.isActive;
      toggleSwitch.classList.toggle("active", this.isActive);

      productItems.forEach((item) => {
        const productItemsDataFormProduct = item.querySelector(
          'product-form[data-form="product"]'
        );
        const productItemsDataFormSub = item.querySelector(
          'product-form[data-form="subscription"]'
        );

        if (this.isActive) {
          productItemsDataFormProduct.classList.add("hidden");
          productItemsDataFormSub.classList.remove("hidden");
        } else {
          productItemsDataFormProduct.classList.remove("hidden");
          productItemsDataFormSub.classList.add("hidden");
        }
      });

      this.dispatchEvent(
        new CustomEvent("subscription-change", {
          detail: { active: this.isActive },
          bubbles: true,
        })
      );
    });

    infoIcon.addEventListener("click", (e) => {
      e.stopPropagation();
      tooltip.classList.toggle("show");
    });

    document.addEventListener("click", (e) => {
      if (!tooltip.contains(e.target) && e.target !== infoIcon) {
        tooltip.classList.remove("show");
      }
    });
  }
}

if (!customElements.get("subscription-button")) {
  customElements.define("subscription-button", SubscriptionButton);
}